import { render, staticRenderFns } from "./faceThree.vue?vue&type=template&id=7229ea2b&"
import script from "./faceThree.vue?vue&type=script&lang=js&"
export * from "./faceThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports